import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSites } from 'app/mocks/data/park/sites'

import { api } from 'app/utils/constants'

import { Site } from 'app/types/park/site'

export const getSite = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.sites.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const siteFound = allSites.find((site) => site.id.toString() === id)

        // No site found
        if (!siteFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Site>(siteFound)
    },
)
